/* eslint-disable @nx/enforce-module-boundaries */
import { Component, Inject, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { DialogHeaderComponent } from 'admin-drivers/src/app/common/dialog/components/dialog-header/dialog-header.component';
import { DetailsSideMenuComponent } from './details-side-menu/details-side-menu.component';
import { DetailsGeneralSectionComponent } from './details-general-section/details-general-section.component';
import { DetailsPersonalSectionComponent } from './details-personal-section/details-personal-section.component';
import {
  LoaderIndicatorDirective,
  LoaderService,
} from '@t-llevo/common-ui';
import { DetailsLicenseSectionComponent } from './details-license-section/details-license-section.component';
import { DetailsVehicleSectionComponent } from './details-vehicle-section/details-vehicle-section.component';
import { DetailsClientSectionComponent } from './details-client-section/details-client-section.component';
import { TravelDetailsService } from '../../services/travel-details.service';
import { map } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { Travel } from 'admin-drivers/src/app/common/models/Travel';
import { TagComponent } from 'admin-drivers/src/app/common/components/tag.component';
import { TravelStatusColorPipe } from '../../pipes/travel-status-color.pipe';
import { FormatTravelStatusPipe } from '../../pipes/format-travel-status.pipe';

@Component({
  selector: 't-llevo-travel-details',
  standalone: true,
  imports: [
    AsyncPipe,
    DialogHeaderComponent,
    MatDialogModule,
    DetailsSideMenuComponent,
    DetailsGeneralSectionComponent,
    DetailsPersonalSectionComponent,
    DetailsLicenseSectionComponent,
    DetailsVehicleSectionComponent,
    DetailsClientSectionComponent,
    LoaderIndicatorDirective,
    TagComponent,
    TravelStatusColorPipe,
    FormatTravelStatusPipe,
  ],
  templateUrl: './travel-details.component.html',
  styles: `
    .main-container{
      background: rgb(250, 251, 250);
    }

    .mdc-dialog__content{
        padding-bottom: 0;
    }

    .sidenav{
      position: fixed;
      width: 20%;
    }
  `,
  providers: [LoaderService],
})
export class TravelDetailsComponent {
  activeMenuItem = 'general';
  sideMenu = [
    {
      value: 'general',
      svgIcon: 'view-dasboard-outline',
      title: 'General',
      isOpen: false,
    },
    {
      value: null,
      svgIcon: 'driver',
      title: 'Conductor',
      isOpen: false,
      disabled: this.data.driver ? false : true,
      children: [
        {
          value: 'driver-personal',
          title: 'Personal',
          isOpen: false,
        },
        {
          value: 'driver-licenses',
          title: 'Licencias',
          isOpen: false,
        },
        {
          value: 'driver-vehicle',
          title: 'Vehículo',
          isOpen: false,
        },
      ],
    },
    {
      value: 'client',
      svgIcon: 'account',
      title: 'Cliente',
      isOpen: false,
    },
  ];

  protected loaderSrv = inject(LoaderService);
  private travelDetailsSrv = inject(TravelDetailsService);
  protected travelStatus = toSignal(this.travelDetailsSrv.selectedTravel$.pipe(
    map((data) => data?.status)
  ))

  constructor(
    public dialogRef: MatDialogRef<TravelDetailsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: Travel
  ) {
    this.dialogRef.afterOpened().subscribe(() => this.afterOpened());

    this.dialogRef
      .afterClosed()
      .subscribe(() => (this.travelDetailsSrv.selectedTravel = null));
  }

  setActiveMenu(value: string) {
    this.activeMenuItem = value;
  }

  private afterOpened() {
    this.loaderSrv.show();
    this.travelDetailsSrv.getTravelById(this.data.id).subscribe(() => {
      this.loaderSrv.hide();
    });
  }
}
